export const OHL  = {
    voltage: '110',
    regionCode: 'INTER',
    name: 'DV 149 TS ZAJEČAR 1 - granica/TS KULA',
    stanice: [],
    position: 'S',
    positionOnPoles: 'Right',
    stubovi: [
        { index: 1, name: 'P-05', lat: 43.9133 , lng: 22.2795, sys: 1, portal: true},
        { index: 2, name: '1', lat: 43.9131 , lng: 22.2813, sys: 2},
        { index: 3, name: '2', lat: 43.9128 , lng: 22.2845, sys: 2},
        { index: 4, name: '3', lat: 43.9131 , lng: 22.2861, sys: 2},
        { index: 5, name: '4', lat: 43.9136 , lng: 22.2883, sys: 2},
        { index: 6, name: '5', lat: 43.9137 , lng: 22.2915, sys: 2},
        { index: 7, name: '6', lat: 43.914 , lng: 22.2936, sys: 2},
        { index: 8, name: '7', lat: 43.9139 , lng: 22.2973, sys: 2},
        { index: 9, name: '8', lat: 43.9139 , lng: 22.2991, sys: 2},
        { index: 10, name: '9', lat: 43.9138 , lng: 22.3036, sys: 2},
        { index: 11, name: '10', lat: 43.9138 , lng: 22.3076, sys: 2},
        { index: 12, name: '11', lat: 43.9125 , lng: 22.3098, sys: 2},
        { index: 13, name: '11A', lat: 43.9121 , lng: 22.312, sys: 1},
        { index: 14, name: '12', lat: 43.9118 , lng: 22.3135, sys: 1},
        { index: 15, name: '13', lat: 43.911 , lng: 22.3174, sys: 1},
        { index: 16, name: '14', lat: 43.91 , lng: 22.3221, sys: 1},
        { index: 17, name: '15', lat: 43.9092 , lng: 22.3262, sys: 1},
        { index: 18, name: '16', lat: 43.9085 , lng: 22.3298, sys: 1},
        { index: 19, name: '17', lat: 43.9074 , lng: 22.3348, sys: 1},
        { index: 20, name: '18', lat: 43.9063 , lng: 22.3402, sys: 1},
        { index: 21, name: '19', lat: 43.9055 , lng: 22.3443, sys: 1},
        { index: 22, name: '20', lat: 43.9045 , lng: 22.3489, sys: 1},
        { index: 23, name: '21', lat: 43.9038 , lng: 22.3527, sys: 1},
        { index: 24, name: '22', lat: 43.9037 , lng: 22.3566, sys: 1},
        { index: 25, name: '23', lat: 43.9036 , lng: 22.3605, sys: 1},
        { index: 26, name: '24', lat: 43.9035 , lng: 22.3668, sys: 1},
        { index: 27, name: '25', lat: 43.9034 , lng: 22.3707, sys: 1},
        { index: 28, name: '26', lat: 43.9033 , lng: 22.3742, sys: 1},
        { index: 29, name: '26A', lat: 43.9032 , lng: 22.3766, sys: 1},
        { index: 30, name: '27', lat: 43.9031 , lng: 22.3794, sys: 1},
        { index: 31, name: '28', lat: 43.903 , lng: 22.3834, sys: 1},
        { index: 32, name: '29', lat: 43.9029 , lng: 22.3871, sys: 1},
        { index: 33, name: '30', lat: 43.9029 , lng: 22.3908, sys: 1},
        { index: 34, name: 'D.G.BG', lat: 43.9029 , lng: 22.3923, sys: 1, portal: true}
    ],
    rasponi: [
        { name: 'P-05 - 1', position: [{ lat: 43.9133 , lng: 22.2795 }, { lat: 43.9131 , lng: 22.2813 }] },
        { name: '1 - 2', position: [{ lat: 43.9131 , lng: 22.2813 }, { lat: 43.9128 , lng: 22.2845 }] },
        { name: '2 - 3', position: [{ lat: 43.9128 , lng: 22.2845 }, { lat: 43.9131 , lng: 22.2861 }] },
        { name: '3 - 4', position: [{ lat: 43.9131 , lng: 22.2861 }, { lat: 43.9136 , lng: 22.2883 }] },
        { name: '4 - 5', position: [{ lat: 43.9136 , lng: 22.2883 }, { lat: 43.9137 , lng: 22.2915 }] },
        { name: '5 - 6', position: [{ lat: 43.9137 , lng: 22.2915 }, { lat: 43.914 , lng: 22.2936 }] },
        { name: '6 - 7', position: [{ lat: 43.914 , lng: 22.2936 }, { lat: 43.9139 , lng: 22.2973 }] },
        { name: '7 - 8', position: [{ lat: 43.9139 , lng: 22.2973 }, { lat: 43.9139 , lng: 22.2991 }] },
        { name: '8 - 9', position: [{ lat: 43.9139 , lng: 22.2991 }, { lat: 43.9138 , lng: 22.3036 }] },
        { name: '9 - 10', position: [{ lat: 43.9138 , lng: 22.3036 }, { lat: 43.9138 , lng: 22.3076 }] },
        { name: '10 - 11', position: [{ lat: 43.9138 , lng: 22.3076 }, { lat: 43.9125 , lng: 22.3098 }] },
        { name: '11 - 11A', position: [{ lat: 43.9125 , lng: 22.3098 }, { lat: 43.9121 , lng: 22.312 }] },
        { name: '11A - 12', position: [{ lat: 43.9121 , lng: 22.312 }, { lat: 43.9118 , lng: 22.3135 }] },
        { name: '12 - 13', position: [{ lat: 43.9118 , lng: 22.3135 }, { lat: 43.911 , lng: 22.3174 }] },
        { name: '13 - 14', position: [{ lat: 43.911 , lng: 22.3174 }, { lat: 43.91 , lng: 22.3221 }] },
        { name: '14 - 15', position: [{ lat: 43.91 , lng: 22.3221 }, { lat: 43.9092 , lng: 22.3262 }] },
        { name: '15 - 16', position: [{ lat: 43.9092 , lng: 22.3262 }, { lat: 43.9085 , lng: 22.3298 }] },
        { name: '16 - 17', position: [{ lat: 43.9085 , lng: 22.3298 }, { lat: 43.9074 , lng: 22.3348 }] },
        { name: '17 - 18', position: [{ lat: 43.9074 , lng: 22.3348 }, { lat: 43.9063 , lng: 22.3402 }] },
        { name: '18 - 19', position: [{ lat: 43.9063 , lng: 22.3402 }, { lat: 43.9055 , lng: 22.3443 }] },
        { name: '19 - 20', position: [{ lat: 43.9055 , lng: 22.3443 }, { lat: 43.9045 , lng: 22.3489 }] },
        { name: '20 - 21', position: [{ lat: 43.9045 , lng: 22.3489 }, { lat: 43.9038 , lng: 22.3527 }] },
        { name: '21 - 22', position: [{ lat: 43.9038 , lng: 22.3527 }, { lat: 43.9037 , lng: 22.3566 }] },
        { name: '22 - 23', position: [{ lat: 43.9037 , lng: 22.3566 }, { lat: 43.9036 , lng: 22.3605 }] },
        { name: '23 - 24', position: [{ lat: 43.9036 , lng: 22.3605 }, { lat: 43.9035 , lng: 22.3668 }] },
        { name: '24 - 25', position: [{ lat: 43.9035 , lng: 22.3668 }, { lat: 43.9034 , lng: 22.3707 }] },
        { name: '25 - 26', position: [{ lat: 43.9034 , lng: 22.3707 }, { lat: 43.9033 , lng: 22.3742 }] },
        { name: '26 - 26A', position: [{ lat: 43.9033 , lng: 22.3742 }, { lat: 43.9032 , lng: 22.3766 }] },
        { name: '26A - 27', position: [{ lat: 43.9032 , lng: 22.3766 }, { lat: 43.9031 , lng: 22.3794 }] },
        { name: '27 - 28', position: [{ lat: 43.9031 , lng: 22.3794 }, { lat: 43.903 , lng: 22.3834 }] },
        { name: '28 - 29', position: [{ lat: 43.903 , lng: 22.3834 }, { lat: 43.9029 , lng: 22.3871 }] },
        { name: '29 - 30', position: [{ lat: 43.9029 , lng: 22.3871 }, { lat: 43.9029 , lng: 22.3908 }] },
        { name: '30 - D.G.BG', position: [{ lat: 43.9029 , lng: 22.3908 }, { lat: 43.9029 , lng: 22.3923 }] }
    ]
}
